// Abratel deployment serves Brazilian customers exclusively — force BR/+55
// as the default phone country regardless of the browser timezone. The
// upstream helper inferred from Intl timezone, which returned US when the
// browser was in any US-recognized zone (very common on agent workstations).

export const getActiveDialCode = () => '+55';

export const getActiveCountryCode = () => 'BR';
